import { SupplierState } from 'data/__generated__';

export const SUPPLIER_STATES_LABELS = {
    [SupplierState.Archived]: 'Archivé',
    [SupplierState.Regular]: 'Normal',
};
